import React from 'react';
import { Div, P, Span } from '@kizi/core-components';
import { useFields } from '@kizi/comparator-core';

export const OverviewTopMessage = () => {
  const [street, houseNumber, apiProducts] = useFields([
    'startWidget.street',
    'startWidget.housenumber',
    'overview.apiProducts',
  ]);

  if (!apiProducts?.value) return null;

  return (
    <Div>
      <P variant="bodyRegular" textAlign="center">
        {'Er zijn '}
        <Span fontWeight={1}>
          {JSON.parse(apiProducts?.value as string).length}
        </Span>
        {' pakketten beschikbaar op '}
        <Span fontWeight={1}>{`${street?.value} ${houseNumber?.value}`}</Span>
      </P>
    </Div>
  );
};
